import StudioModal from '@/components/modals/StudioModal.vue';
import { Component } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import Base from '../Base';
import PaymentForm from './PaymentForm.vue';
import NotificationHelper from '@/helpers/notification';
import SubscriptionApi from '@/apis/subscription-api';
import { Spinner } from 'streamlabs-beaker';
import DisclaimerCheckbox from '@/components/checkout/DisclaimerCheckbox.vue';

@Component({
  components: {
    SSpinner: Spinner,
    StudioModal,
    PaymentForm,
    DisclaimerCheckbox,
  },
})
export default class UpdatePaymentMethodModal extends Base {
  updateProcessing: boolean = false;
  $refs!: {
    paymentForm: PaymentForm;
  };

  get modalName(): string {
    return EModalName.updatePaymentMethod;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  async updatePaymentMethod(braintreePayload) {
    this.updateProcessing = true;
    const data = {
      paymentPayload: braintreePayload,
      hasAgreedToTerms: this.hasAgreedToTerms,
    };

    const response = await SubscriptionApi.updatePaymentMethod(data);
    this.updateProcessing = false;

    if (response.success) {
      NotificationHelper.success('Payment Method has updated!');
      this.userPaymentMethod = response.paymentMethod;
      this.hasAgreedToTerms = false;
    } else {
      NotificationHelper.error(response.message);
      return;
    }

    this.hideModal();
  }

  onConfirm() {
    if (!this.hasAgreedToTerms) {
      this.displayAgreeToTermsError = true;
      return;
    }

    this.displayAgreeToTermsError = false;
    this.$refs.paymentForm.submit();
  }

  onModalClosed() {
    this.hasAgreedToTerms = false;
  }
}
